export const REVIEW_MODE_SIDE_PANEL_EVENT_NAMES = Object.freeze({
  UPDATE_ANNOTATION_REVIEW: 'update_annotation_review',
  REVIEW_ANNOTATION_ACCEPT: 'review_annotation_accept',
  REVIEW_ANNOTATION_REJECT: 'review_annotation_reject',
  REVIEW_FILTER: 'review_filter',
  REVIEW_ANNOTATIONS_VISIBILITY: 'review_annotations_visibility',
  REVIEW_PAGE_CHANGE: 'review_page_change',
  REVIEW_ANNOTATION_NOTE: 'review_annotation_note',
  REVIEW_ANNOTATION_SAVE: 'review_annotation_save',
  REVIEW_ANNOTATION_CANCEL: 'review_annotation_cancel',
  REVIEW_ANNOTATION_REVERT: 'review_annotation_revert',
  REVIEW_FEEDBACK_PANEL_TOGGLE: 'review_feedback_panel_toggle'
});